import React from 'react'
import SliderHome from '../Components/Slider'
import StudentSlider from  '../Components/StudentSlider/StudentSlider'
import StudentDetails from '../Components/StudentSlider/StudentDetails'
import DevploperDetail from '../Components/Developer/DeveploperDetail'
import AboutInHome from '../Components/AboutInHome'
import ScholarshipForm from './ScholarshipForm'
import {useNavigate} from 'react-router-dom'
import {Routes,Route} from 'react-router-dom'
import Dynamic from '../Components/Dynamic'
import NavBar from "../Components/Navb"
import Footer from '../Components/Footer';
import { Box } from '@chakra-ui/react'

const Home = () => {
  const navigate=useNavigate()
  return (
    <Box>
       <NavBar/>
        <SliderHome/>
     
        <AboutInHome/>
      
        
        <StudentSlider/>
        <Footer/>
    </Box>
  )
}

export default Home